import { NgModule } from '@angular/core';

import { DevFlagsDataModule } from '@recruitee/dev-flags-data';

import { DevFlagDirective } from './directives/dev-flags.directive';

@NgModule({
  imports: [DevFlagsDataModule, DevFlagDirective],
  exports: [DevFlagDirective],
})
export class DevFlagsModule {}
